import { StockStoreType } from '../context'
import { useContext, useMemo } from 'react'
import { StockStoreTypeMap, StockStoreTypeEnum } from '../config'
export default function useStockStoreTypeContext() {
  const { stockStoreType } = useContext(StockStoreType)
  const { stockTypeText, isRealStock } = useMemo(
    () => ({
      stockTypeText: StockStoreTypeMap[stockStoreType],
      isRealStock: stockStoreType === StockStoreTypeEnum[0]
    }),
    [stockStoreType]
  )
  return { stockStoreType, stockTypeText, isRealStock }
}
